import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const ShopList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Map = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ShopItem = styled.div<{$active: boolean}>`
  display: flex;
  flex-direction: column;

  gap: 10px;
  cursor: pointer;
  padding: 18px 15px;
  border-radius: 5px;
  border: solid 1px ${theme.colors.gray6};

  &:hover${props => props.$active && ', &'} {
    transition: transform ease 0.3s;
    background: ${theme.colors.dark4};
    color: ${theme.colors.white};
    transform: scale(1.015);
  }

  @media ${media.md} {
    flex-direction: row;
    gap: 33px;
  }
`

export const ShopItemName = styled.div`
  width: 150px;

  font-size: 1.25rem;
  font-weight: 450;
`

export const ShopItemAddress = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  @media ${media.md} {
    width: 176px;
    text-align: right;
  }
`

export const ShopItemSchedule = styled.div`
  white-space: normal;
  text-align: left;

  @media ${media.md} {
    width: 129px;
  }
`

export const ShopFormTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 8px;

  & .ant-radio-button-label {
    white-space: nowrap;
  }

  & .ant-radio-button-label,
  & .ant-radio-button-wrapper {
    &:hover {
      color: ${theme.colors.dark4};
    }
  }

  & .ant-radio-button-wrapper {
    height: 100%;
    line-height: unset;
    padding: 2px 15px;
  }

  & .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: ${theme.colors.dark4};
    border-color: ${theme.colors.dark4};

    &:hover {
      color: ${theme.colors.white};
    }

    & .ant-radio-button-label {
      &:hover {
        color: ${theme.colors.white};
      }
    }
  }
`
export const SelectedLab = styled.div`
  font-weight: 450;
`
